<template>
  <div class="solutions-area section-width ptb-100">
    <div class="container">
      <div class="section-title">
        <h2>{{ $t("navbar.menu_1_5") }}</h2>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incidiunt labore et dolore magna aliqua. Quis ipsum
          suspendisse ultrices gravida.
        </p>
      </div>
      <section class="blog-area pb-70">
        <div class="container">
          <div class="facility-section block1">
            <ul class="row">
              <li class="card mb-3" v-for="(hotel, index) in hotels" :key="index">
                <div class="row no-gutters" :class="{ 'flex-row-reverse': index % 2 === 1 }">
                  <div class="col-md-4">
                    <img
                      :src="require(`@/assets/project_images/accommodation/${hotel.image}`)"
                      alt="Image"
                    />
                  </div>
                  <div class="col-md-8">
                    <div class="card-body text-left">
                      <h5 class="card-title">
                        {{ $t(hotel.titleKey) }}
                      </h5>
                      <p class="card-text" v-html="$t(hotel.contentKey)"></p>
                      <p class="card-text">
                        <small class="text-muted"></small>
                      </p>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
  import SmoothScroll from 'smooth-scroll';
  export default {
    name: 'AccommodationBody',
    data() {
      return {
        selected: null,
        hotels: [
          {
            image: 'taiurbanresort.jpg',
            titleKey: 'section_1.item_13.title',
            contentKey: 'section_1.item_13.content',
          },
          {
            image: 'InterContinental.jpg',
            titleKey: 'section_1.item_12.title',
            contentKey: 'section_1.item_12.content',
          },
          {
            image: 'Hotel_Nikko.jpg',
            titleKey: 'section_1.item_17.title',
            contentKey: 'section_1.item_17.content',
          },
          {
            image: 'Hotel_Amnis.jpg',
            titleKey: 'section_1.item_18.title',
            contentKey: 'section_1.item_18.content',
          },
          {
            image: 'cityRestHilai.jpg',
            titleKey: 'section_1.item_1.title',
            contentKey: 'section_1.item_1.content',
          },
          // {
          //   image: 'SilksClub.jpg',
          //   titleKey: 'section_1.item_2.title',
          //   contentKey: 'section_1.item_2.content',
          // },
          {
            image: 'COZZI.jpg',
            titleKey: 'section_1.item_8.title',
            contentKey: 'section_1.item_8.content',
          },
          {
            image: 'cityRestSunshine.jpg',
            titleKey: 'section_1.item_11.title',
            contentKey: 'section_1.item_11.content',
          },
          {
            image: 'han-hsien.jpg',
            titleKey: 'section_1.item_15.title',
            contentKey: 'section_1.item_15.content',
          },
          {
            image: 'citysuites.jpg',
            titleKey: 'section_1.item_9.title',
            contentKey: 'section_1.item_9.content',
          },
          {
            image: 'CDCK.jpg',
            titleKey: 'section_1.item_10.title',
            contentKey: 'section_1.item_10.content',
          },
          {
            image: 'thelees.jpg',
            titleKey: 'section_1.item_5.title',
            contentKey: 'section_1.item_5.content',
          },
          {
            image: 'Indigo.jpg',
            titleKey: 'section_1.item_3.title',
            contentKey: 'section_1.item_3.content',
          },
          {
            image: 'Hotel_dua.jpg',
            titleKey: 'section_1.item_16.title',
            contentKey: 'section_1.item_16.content',
          },
          {
            image: 'Howard.jpg',
            titleKey: 'section_1.item_4.title',
            contentKey: 'section_1.item_4.content',
          },
          {
            image: 'marriott.jpg',
            titleKey: 'section_1.item_14.title',
            contentKey: 'section_1.item_14.content',
          },
          {
            image: 'H2O.png',
            titleKey: 'section_1.item_7.title',
            contentKey: 'section_1.item_7.content',
          },
        ],
        options: [
          {
            value: null,
            text: '預計的人數 / 攤位數',
          },
          {
            value: 'a',
            text: 'This is First option',
          },
          {
            value: 'b',
            text: 'Selected Option',
          },
          {
            value: {
              C: '3PO',
            },
            text: 'This is an option with object value',
          },
          {
            value: 'd',
            text: 'This one is disabled',
            disabled: true,
          },
        ],
      };
    },
    methods: {
      goAnchor(selector) {
        const scroll = new SmoothScroll();
        const anchor = document.querySelector(selector);
        scroll.animateScroll(anchor, null, {
          //updateURL: false,
          speed: 800,
        });
      },
    },
  };
</script>

<style scoped>
.facility-section .card-body {
  min-height: 350px;
}
.solutions-area.section-width .container {
  max-width: 1000px;
}

.facility-section {
  margin-top: 40px;
  text-align: center;
}

.blog-content {
  text-align: left;
}

.single-blog-post .blog-content h3 {
  margin-bottom: 13px;
}

.card img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.block2 .card img {
  width: 100%;
}

.card-footer {
  font-size: 16px;
}

.single-blog-post img {
  width: 300px;
  height: 300px;
  object-fit: cover;
}

:target:before {
  content: "";
  display: block;
  height: 80px;
}

hr {
  background-color: #000000;
  height: 3px;
  border: none;
  margin: 30px 0;
}

.cover-image {
  margin-bottom: 50px;
  width: 100%;
  height: 400px;
}

.fs-btn {
  margin-left: 30px;
  margin-bottom: 30px;
  padding-left: 30px;
  padding-right: 30px;
}
</style>
